import { render } from "./MainMasterpage.vue?vue&type=template&id=c6ec4146&scoped=true"
import script from "./MainMasterpage.vue?vue&type=script&lang=js"
export * from "./MainMasterpage.vue?vue&type=script&lang=js"

import "./MainMasterpage.vue?vue&type=style&index=0&id=c6ec4146&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6ec4146"]])

export default __exports__